import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import newLogo from "../../assets/new_logo.png";
import AxiosInstance from "../../AxiosInstance";
import { message } from "antd";
import { parse } from "@fortawesome/fontawesome-svg-core";
import OtpInput from "../Otp/otpinput";
import AadhaarOtpInput from "../Otp/aadharOtp";
const VerifyAadharModal = (props) => {
  const close = () => {
    props.setActive(false);
  };
  const navigate = () => {
    console.log();
    close();
  };
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState({});
  const [otp, setOtp] = useState("");
  const handleChange = (code) => setOtp(code);
  useEffect(() => {
    if (props.active) {
      getUserPanData();
    }
  }, [props.aadhar, props.active]);
  const getUserPanData = async () => {
    const result = await AxiosInstance()
      .post("/common/generateAadhaarOtp", {
        aadhaar: parseInt(props?.aadhar),
      })
      .catch((err) => {
        message.error(err.response.data.message);
        // alertError();
      });
    console.log(result);
    if (result.status === 200) {
      message.success("OTP sent to registered mobile number");
      setLoading(false);
      setUserData(result.data.data);
    } else {
    }
  };
  const markAadhaarVerified = async (otp, client_id) => {
    const result = await AxiosInstance()
      .put("/profile/markAadhaarAsVerified", {
        otp: otp,
        clientId: client_id,
      })
      .catch((err) => {
        console.log();
        close();
        message.error(err.response.data.message);
        // alertError();
      });
    console.log(result);
    if (result.status === 200) {
      props.setPanVerified(true);
      message.success("Aadhaar Verified Successfully");
      console.log();
      close();
    } else {
    }
  };
  return (
    <div>
      <Modal
        show={props.active}
        centered
        onHide={() => {
          props.setActive(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Verify Aadhaar Number</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row py-4">
            <div className=" d-flex justify-content-center">
              <AadhaarOtpInput sendData={handleChange}></AadhaarOtpInput>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            className="px-5 py-2 mx-1"
            variant="outline-primary"
            onClick={() => {
              close();
            }}
          >
            Close
          </Button>
          <Button
            disabled={otp.length !== 6}
            className="mx-1 px-4 py-2"
            onClick={() => {
              markAadhaarVerified(otp, userData?.client_id);
            }}
          >
            Continue
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default VerifyAadharModal;
